import { useLocation } from "react-router-dom";

const PHONE = "491732354407"; // +49 173 235 4407
const MESSAGE = "Hi Lorenz, ich hätte ein Projekt. Ruf mich gerne mal an.";

const WhatsAppFloat = () => {
  const { pathname } = useLocation();
  // Hide on legal & utility routes
  if (["/impressum", "/datenschutz", "/agb", "/unsubscribe"].includes(pathname)) {
    return null;
  }

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Kontakt"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 transition-transform duration-300 hover:scale-110 active:scale-95 md:bottom-6 md:right-6 md:h-16 md:w-16"
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
      />
      <svg
        viewBox="0 0 32 32"
        className="relative h-7 w-7 md:h-8 md:w-8"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.21c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.21 5.1 4.5.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
        <path d="M26.78 5.22A14.94 14.94 0 0 0 16.04 1C7.74 1 1 7.74 1 16.04c0 2.65.69 5.24 2.01 7.52L1 31l7.62-2c2.2 1.2 4.68 1.83 7.21 1.83h.01c8.3 0 15.04-6.74 15.04-15.04 0-4.02-1.56-7.79-4.1-10.57zM16.04 28.31h-.01c-2.26 0-4.47-.61-6.4-1.76l-.46-.27-4.52 1.19 1.21-4.41-.3-.47a12.45 12.45 0 0 1-1.91-6.55c0-6.9 5.61-12.51 12.51-12.51 3.34 0 6.48 1.3 8.84 3.67a12.42 12.42 0 0 1 3.67 8.84c0 6.9-5.61 12.51-12.63 12.51z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
